import { http } from './base'

const getList = (params) => {
  return http.get('job/getJobList', params)
}
const search = (params) => {
  return http.get('job/search', params)
}

const getCategory = (params) => {
  return http.get('category', params)
}

const getDetails = (params) => {
  return http.get('job/getJobById', params)
}

export default {
  getList,
  search,
  getCategory,
  getDetails
}
